import ValorParametroResultDTO from '../dtos/ValorParametroResultDTO';
import api from './api';

export default {
  getValorDinamico: async (chave: string): Promise<ValorParametroResultDTO> => {
    const { data } = await api.get<ValorParametroResultDTO>(
      `parametro/dinamico/${chave}`,
    );
    return data;
  },
};
